import '../../../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'dialogSelectShot';
class DialogSelectShot {
  /* @ngInject */
  constructor (
    $rootScope, $scope, $sessionStorage,
    Resource, SharedState, Const
  ) {
    this.Const = Const;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.UiSharedState = SharedState;
    this.Resource = Resource;

    this.seriesLegend = [
      this.Const.SHOT_TYPE.all,
      this.Const.SHOT_TYPE.foreF,
      this.Const.SHOT_TYPE.foreS,
      this.Const.SHOT_TYPE.backF,
      this.Const.SHOT_TYPE.backS,
      this.Const.SHOT_TYPE.foreV,
      this.Const.SHOT_TYPE.backV,
      this.Const.SHOT_TYPE.smash,
      this.Const.SHOT_TYPE.serve
    ];

    this.legendStyle = [
      this.Const.SHOT_COLOR.all,
      this.Const.SHOT_COLOR.foreF,
      this.Const.SHOT_COLOR.foreS,
      this.Const.SHOT_COLOR.backF,
      this.Const.SHOT_COLOR.backS,
      this.Const.SHOT_COLOR.foreV,
      this.Const.SHOT_COLOR.backV,
      this.Const.SHOT_COLOR.smash,
      this.Const.SHOT_COLOR.serve
    ];

    DialogSelectShot.$inject = [
      '$rootScope', '$scope', '$sessionStorage',
      'Resource', 'SharedState', 'Const'
    ];
  }

  selectShot ($event, $index) {
    let that = this;
    this.beforeAddStyle($event, $index, that)
    .then(($index) => {
      // シークバーの高さ調整
      let extentEle = document.getElementsByClassName('extent');
      extentEle[0].setAttribute('height', '24');
      // スライダーの領域調整
      let resizeEle = document.getElementsByClassName('resize');
      let resizeE = resizeEle[0].getElementsByTagName('rect');
      let resizeW = resizeEle[1].getElementsByTagName('rect');
      resizeE[0].setAttribute('width', '50');
      resizeW[0].setAttribute('width', '50');
      resizeE[0].setAttribute('height', '40');
      resizeW[0].setAttribute('height', '40');
      this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', (d) => {
        return this.legendStyle[$index];
      });
      this.$rootScope.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', (d) => {
        return this.legendStyle[$index];
      });
      this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', (d) => {
        return this.Const.SHOT_COLOR.deselected;
      });
      this.$rootScope.userSeriesChart.colorAccessor((d) => {
        if (d.value) {
          this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar').style('fill', (d) => {
            return this.legendStyle[$index];
          });
          this.$rootScope.userSeriesChart.select('.dc-chart .brush rect.extent').style('fill', (d) => {
            return this.legendStyle[$index];
          });
          this.$rootScope.userSeriesChart.selectAll('.dc-chart rect.bar.deselected').style('fill', (d) => {
            return this.Const.SHOT_COLOR.deselected;
          });
        }
      });
    })
    .catch((error) => {
      console.error('error : ', error);
    });
  }

  beforeAddStyle ($event, $index, that) {
    return new Promise(function (resolve) {
      /*
        ダイアログでは$sessionStorageを取得できないため、
        graph.es6のshowSelectShot()内で$rootScopeに値を代入している
      */
      let beginDate = new Date(that.$rootScope.lessonBeginDate);
      let endDate = new Date(that.$rootScope.lessonEndDate);
      let targetShotKind = '';
      if ($event.target.defaultValue) {
        targetShotKind = $event.target.defaultValue;
      } else {
        let trimInnerText = $event.target.innerText.trim();
        targetShotKind = trimInnerText;
      }
      if (that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === targetShotKind) {
        that.UiSharedState.turnOff('dialogSelectShotPopup');
        return resolve($index);
      }
      that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] = targetShotKind;
      if ($index === 0) {
        // すべてのショット選択時はHeatmapを表示させない
        that.$sessionStorage[that.Const.SSAPP_HEATMAP_FLG] = false;
        dc.filterAll();
        that.$rootScope.userSeriesChart.filter([beginDate, endDate]);
        dc.renderAll();
        that.UiSharedState.turnOff('dialogSelectShotPopup');
        return resolve($index);
      } else {
        // データに合わせフォアハンド スピン/フラットを0とする
        let idx = $index - 1;
        // すべてのショット選択時はHeatmapを表示させる
        that.$sessionStorage[that.Const.SSAPP_HEATMAP_FLG] = true;
        // 正しい情報を表示するため一度リセットしてからフィルターをかける
        dc.filterAll();
        that.$rootScope.userSeriesChart.filter([beginDate, endDate]);
        // ダイアログで選択したショットでフィルターをかける
        that.$rootScope.swingtypeChart._onClick(that.$rootScope.swingtypeChart.data()[idx]);
        dc.renderAll();
        that.UiSharedState.turnOff('dialogSelectShotPopup');
        return resolve($index);
      }
    });
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: DialogSelectShot,
    templateUrl: 'app/components/dialog/select-shot/dialog-select-shot.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/dialog/select-shot/dialog-select-shot-controller.es6